import BaseRepository from '@/core/standard/BaseRepository';
import {axiosInstance} from '@/setup/axios/AxiosConfig';
import {GenericMethod, UrlParams} from '@/core/Types/IRepository';

class AuthServices extends BaseRepository {
  public collection = 'products';
  public version = 'v1';

  public async batchDelete<T = any>(params: UrlParams<T>): Promise<any> {
    return super.request({...params, url: 'delete_all', method: 'post'});
  }

  public async getProductOrder<T = any>(params: GenericMethod<T>): Promise<any> {
    return super.request({url: `get_product_order/${params.id}`, method: 'get'});
  }

  public async getAllRecipes(params: GenericMethod) {
    return this.request({...params, url: 'scandals'});
  }

  public async changeCategories<T = any>(params: UrlParams<T>): Promise<any> {
    return this.request({...params, url: 'update_categories_all', method: 'post'});
  }

  public getProduct(params: GenericMethod) {
    return this.getBy({url: `get_product_order/${params.id}`});
  }

  public async getProductsListByLocal(params: GenericMethod) {
    return this.request({...params, url: 'list_bar'});
  }
}

export default new AuthServices(axiosInstance);
